class NotificationWebSocketService {
  constructor() {
    this.ws = null;
    this.canalAtual = null;
    this.connected = false;
    this.reconnectAttempts = 0;
    this.maxReconnectAttempts = 5;
    this.reconnectDelay = 3000;
    this.notificacoes = [];
    this.callbacks = {
      onConnect: [],
      onDisconnect: [],
      onNotification: [],
      onError: [],
    };
    
    const apiUrl = process.env.VUE_APP_API_URL;
    
    if (!apiUrl) {
      console.error('[NotificationWebSocket] VUE_APP_API_URL não está definido!');
      this.wsBaseUrl = 'ws://localhost:8092/';
    } else {
      this.wsBaseUrl = apiUrl.replace('http://', 'ws://').replace('https://', 'wss://');
    }
  }

  conectarCanal(nomeCanal = 'geral') {
    return new Promise((resolve, reject) => {
      try {
  
        if (this.ws && this.connected) {
          this.desconectar();
        }

        const token = localStorage.getItem('tokenAccess');
        
        if (!token) {
          const error = 'Token de autenticação não encontrado';
          console.error('[NotificationWS] Erro:', error);
          reject(new Error(error));
          return;
        }

        this.canalAtual = nomeCanal;
        const wsUrl = `${this.wsBaseUrl}ws/notificacoes/${nomeCanal}/?token=${token}`;
        
        this.ws = new WebSocket(wsUrl);
        
        this.ws.onopen = () => {
          this.connected = true;
          this.reconnectAttempts = 0;
          this._triggerCallbacks('onConnect', { canal: nomeCanal });
          resolve(true);
        };

        this.ws.onmessage = (event) => {
          try {
            const data = JSON.parse(event.data);
            this.handleMessage(data);
          } catch (error) {
            console.error('[NotificationWS] Erro ao processar mensagem:', error);
          }
        };

        this.ws.onerror = (error) => {
          console.error('[NotificationWS] Erro na conexão:', error);
          this._triggerCallbacks('onError', error);
        };

        this.ws.onclose = (event) => {
          this.connected = false;
          this._triggerCallbacks('onDisconnect', { canal: nomeCanal, code: event.code });

          if (event.code !== 1000 && this.reconnectAttempts < this.maxReconnectAttempts) {
            this.reconnectAttempts++;
            setTimeout(() => {
              this.conectarCanal(nomeCanal);
            }, this.reconnectDelay);
          }
        };

      } catch (error) {
        console.error('[NotificationWS] Erro ao conectar:', error);
        reject(error);
      }
    });
  }

  conectarCanalUsuario(userId) {
    const canalUsuario = `user_${userId}`;
    return this.conectarCanal(canalUsuario);
  }

  handleMessage(data) {
    if (data.mensagem && data.tipo !== 'conectado' && data.tipo !== 'erro') {
      this._handleNotificacao(data);
      return;
    }

    switch (data.tipo) {
      case 'notificacao':
        this._handleNotificacao(data);
        break;

      case 'erro':
        this._handleErro(data);
        break;

      default:
        break;
    }
  }

  _handleNotificacao(data) {
    this.notificacoes.push(data);
    this._triggerCallbacks('onNotification', data);
  }

  _handleErro(data) {
    console.error('[NotificationWS] Erro do servidor:', data.mensagem);
  }

  desconectar() {
    if (this.ws) {
      this.ws.close(1000, 'Desconexão intencional');
      this.ws = null;
      this.connected = false;
      this.canalAtual = null;
      this.notificacoes = [];
    }
  }

  on(evento, callback) {
    if (this.callbacks[evento]) {
      this.callbacks[evento].push(callback);
    }
  }

  off(evento, callback) {
    if (this.callbacks[evento]) {
      this.callbacks[evento] = this.callbacks[evento].filter((cb) => cb !== callback);
    }
  }

  _triggerCallbacks(evento, data) {
    if (this.callbacks[evento]) {
      this.callbacks[evento].forEach((callback) => {
        try {
          callback(data);
        } catch (error) {
          console.error(`[NotificationWS] Erro ao executar callback ${evento}:`, error);
        }
      });
    }
  }
}

const notificationWebSocketService = new NotificationWebSocketService();

export default notificationWebSocketService;
